import styled, { css } from 'styled-components';
import { Button, Tag } from '@tryhackme/thm-ui-components';

export const StyledContainer = styled.div`
  display: flex;
  align-items: flex-end;
  flex: 1;
`;

export const StyledForm = styled.form<{
  $splitScreenOpen: boolean;
}>`
  gap: 1.6rem;
  flex: 1;
  display: flex;
  flex-wrap: wrap;
  @media screen and (max-width: ${({ theme }) => theme.sizes.md}) {
    justify-content: center;
  }

  ${({ $splitScreenOpen }) =>
    $splitScreenOpen &&
    css`
      justify-content: center;
    `}
`;

export const StyledAutoAnswerContainer = styled.div`
  flex: 3;
  display: flex;
  align-items: center;
  gap: 1.6rem;
  width: 100%;
  min-width: min(34rem, 100%);
`;

export const StyledTextfieldContainer = styled.div<{ $splitScreenOpen: boolean }>`
  flex: 3;
  flex-direction: row;
  min-width: min(34rem, 100%);
  @media screen and (max-width: ${({ theme }) => theme.sizes.md}) {
    width: 100%;
  }

  ${({ $splitScreenOpen }) =>
    $splitScreenOpen &&
    css`
      width: 100%;
    `}
`;

export const StyledButtonsContainer = styled.div`
  display: flex;
  flex: 1;
  gap: 1.2rem;
  height: 3.6rem;
  min-width: 26rem;
  max-width: 26rem;
  align-items: flex-end;
  justify-content: center;
`;

export const StyledHintButton = styled(Button)`
  flex: 1;
  white-space: nowrap;
  height: 3.6rem;
`;

export const StyledButton = styled(StyledHintButton)<{ isQuestionDone?: boolean }>`
  pointer-events: ${({ isQuestionDone }) => (isQuestionDone ? 'none' : 'pointer')};
`;

export const StyledQuestionContainer = styled.div`
  margin-bottom: 0.9rem;

  p {
    line-height: 2.6rem;
  }

  p:last-child {
    margin-bottom: 0 !important;
  }
`;

export const StyledQuestion = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  margin-top: 2.4rem;
  font-size: ${({ theme }) => theme.fonts.sizes.default};
`;

export const StyledExtraPointsTagAndQuestionContainer = styled.div`
  display: flex;
`;

export const StyledTagContainer = styled.div`
  margin: 0.1rem 0.6rem 1rem 0;
  display: flex;
  padding-top: 0;
  flex: 1;
  justify-content: flex-start;
  align-items: center;
  max-width: fit-content;
`;

export const StyledTag = styled(Tag)`
  display: flex;
  align-items: center;
`;

export const StyledPoints = styled.div`
  color: ${({ theme }) => theme.colors.black};
`;
